import CurrentUser from 'models/CurrentUser';
import { ISubscription } from 'models/Subscription';

class GTM {
  static trackSignup(user: CurrentUser, subscription: ISubscription): void {
    const { signup_summary: signupSummary } = subscription;

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'ordersuccess',
        transactionId: subscription.id,
        transactionAffiliation: 'The Purple Carrot',
        transactionTotal: signupSummary.box_total,
        transactionTax: 0,
        transactionShipping: 0,
        transactionProducts: [{
          sku: user.subscription.plan,
          name: user.subscription.plan,
          category: 'Meals',
          price: signupSummary.box_total,
          quantity: 1,
        }],
      });
    }
  }
}

export default GTM;
